import React from "react";
import { Card, Button } from "react-bootstrap";
import { ActionHandlerFunction, UserProfile } from "@preveil-api";
import { AdminUIActionTypes } from "src/common";
import connectionImage from "src/assets/images/connection.svg";

type AllProps = {
  handleAction: ActionHandlerFunction;
  approver: UserProfile;
}

// Description: Error component showing that the connection is disconnected
function ErrorConnectionComponent(props: AllProps) {
  const { handleAction, approver } = props;
  const { address } = approver;

  return <Card className="pv-card">
    <Card.Img variant="top" src={connectionImage} />
    <Card.Body>
      <h1 className="text-orange border-bottom pb-3">Connection Disconnected</h1>
      <h3>Lost secure connection: Please try again</h3>
      <div className="btn-panel">
        <Button variant="primary" onClick={() => handleAction({ actionType: AdminUIActionTypes.Start, params: { subsumeUser: address } })}>Retry</Button>
        <Button  variant="no-outline-primary" onClick={() => handleAction({ actionType: AdminUIActionTypes.Reset })}>Back</Button>
      </div>
    </Card.Body>
  </Card>;
}

export default React.memo(ErrorConnectionComponent);